import { canv } from "@/canv/global.js";

import { getTarget, isInIframe } from "@/canv/utils.js";
import { saveTextToClipboard } from "@/canvasController/helpers";
import { CommentWidget } from "@/elements/comment/index.js";
import { frameWidget } from "@/elements/frame";
import { eventEmitter } from "@/eventEmitter";
import { mindMapWidget } from "@/elements/mindMap/mindMap.js";
import { Group } from "@/group";
import { selectionManager } from "@/tools/cursorTool";

export class contextMenu {
    constructor() {
        this.isExporting = false;
        eventEmitter.on("button.disabled", (buttonStates) => {
            this.isExporting = buttonStates.export;
        });
    }
    locateContextMenu() {
        var menu = document.getElementsByClassName("contextMenu")[0];

        if (menu == undefined) {
            return;
        }

        var menuSize = menu.getBoundingClientRect();

        var pt = {
            x: canv.actionManager.lastX,
            y: canv.actionManager.lastY,
        };

        var wantedX = pt.x;
        if (wantedX < 10) wantedX = 10;
        if (
            wantedX + menuSize.width + 10 >
            canv.canvas.getBoundingClientRect().width
        )
            wantedX = canv.canvas.getBoundingClientRect().width - menuSize.width - 10;
        menu.style.left = wantedX.toString() + "px";

        var wantedY = pt.y;
        if (wantedY < 10) wantedY = 10;
        if (
            wantedY + menuSize.height + 10 >
            canv.canvas.getBoundingClientRect().height
        )
            wantedY =
                canv.canvas.getBoundingClientRect().height - menuSize.height - 10;
        menu.style.top = wantedY.toString() + "px";
    }

    tryHide() {
        if (!this.isOpened) {
            return false;
        }

        var menu = document.getElementsByClassName("contextMenu")[0];
        menu.outerHTML = "";
        this.isOpened = false;
        return true;
    }

    show() {
        if (
            canv.isBoardModeView() ||
            canv.canvasController.selected[0]?.children[0] instanceof CommentWidget
        ) {
            return;
        }

        var menuDiv = document.createElement("div");
        menuDiv.classList.add("contextMenu");
        document.body.prepend(menuDiv);

        if (canv.canvasController.selected.length != 0) {
            menuDiv.innerHTML = this.buildSelectedContextMenuContent();
        } else {
            menuDiv.innerHTML = this.buildCanvasContextMenuContent();
        }

        const menuItems = document.getElementsByClassName("contextMenuItem");
        for (let i = 0; i < menuItems.length; i++) {
            const menuItem = menuItems[i];
            const subMenu = menuItem.querySelector(".contextSubMenu");

            if (subMenu) {
                menuItem.addEventListener("mouseover", () => {
                    subMenu.style.display = "block";
                    this.adjustSubMenuPosition(subMenu, menuItem);
                });
            } else {
                menuItem.addEventListener(
                    "mouseup",
                    this.contextMenuItemClickProccessor.bind(this),
                    false,
                );
            }

            menuItem.addEventListener("mouseover", () => {
                const openSubMenus = document.querySelectorAll(".contextSubMenu");
                openSubMenus.forEach((openSubMenu) => {
                    if (openSubMenu !== subMenu) {
                        openSubMenu.style.display = "none";
                    }
                });
            });
        }

        this.isOpened = true;
        this.locateContextMenu();
    }

    adjustSubMenuPosition(subMenu, alignBy) {
        const alignByDims = alignBy.getBoundingClientRect();
        const subMenuRect = subMenu.getBoundingClientRect();
        const canvasWidth = canv.canvas.getBoundingClientRect().width;
        const canvasHeight = canv.canvas.getBoundingClientRect().height;

        let wantedX = alignByDims.left + alignByDims.width + 10;
        let wantedY = alignByDims.top - 10;

        if (wantedX < 10) wantedX = 10;
        if (wantedX + subMenuRect.width + 10 > canvasWidth)
            wantedX = alignByDims.left - subMenuRect.width - 10;
        subMenu.style.left = wantedX.toString() + "px";

        if (wantedY < 10) wantedY = 10;
        if (wantedY + subMenuRect.height + 10 > canvasHeight)
            wantedY = canvasHeight - subMenuRect.height - 10;
        subMenu.style.top = wantedY.toString() + "px";
    }

    applyContextMenuItemTemplate(text, shortcut, codeName) {
        // &#8984; command symbol
        var template =
            `
                    <div class="contextMenuItem" codeName=` +
            codeName +
            `>
                        <p class="contextMenuItem_name">` +
            text +
            `</p>
                        <p class="contextMenuItem_shortcut">` +
            shortcut +
            `</p>
                    </div>
                `;

        return template;
    }

    applyContextMenuItemTemplateWithSubMenu(text, shortcut, codeName, items) {
        return (
            `
         <div class="contextMenuItem" codeName=` +
            codeName +
            `>
            <p class="contextMenuItem_name">` +
            text +
            `</p>
            <p class="contextMenuItem_shortcut">` +
            shortcut +
            `</p>
            <div class="contextMenu contextSubMenu">
                ${items
                                    .map(
                                        (item) =>
                                            `
                    <div class="contextMenuItem" codeName=` +
                                            item.codeName +
                                            `>
                        <p class="contextMenuItem_name">` +
                                            item.text +
                                            `</p>
                        <p class="contextMenuItem_shortcut">` +
                                            item.shortcut +
                                            `</p>
                    </div>
                `,
                                    )
                                    .join("")}
            </div>
        </div>
    `
        );
    }

    buildSelectedContextMenuContent() {
        var actionSymbol = canv.actionManager.actionSymbol;

        var menu = ``;
        var dividor = `<div class="contextMenu_dividor"></div>`;

        // пока не добавляю - не везде корректно работает (таблицы, текст)
        // menu += this.applyContextMenuItemTemplate("Вырезать", actionSymbol + " X", "cut");
        menu += this.applyContextMenuItemTemplate(
            "Скопировать",
            actionSymbol + " C",
            "copy",
        );
        menu += this.applyContextMenuItemTemplate(
            "Вставить",
            actionSymbol + " V",
            "paste",
        );
        //menu += this.applyContextMenuItemTemplate("Duplicate", actionSymbol + " D", "duplicate");

        const isOnlyEmbed = (elements) => {
            return elements.every((g) => {
                if (g.children?.[0] instanceof Group) {
                    return isOnlyEmbed(g.children);
                }

                return g.children.every((el) => el.constructorName === "embed");
            });
        };

        const selectOnlyEmbed = isOnlyEmbed(canv.canvasController.selected);

        // выбрана только майндмапа не в режиме редактирования текста
        const isOnlyMindMap =
            canv.toolBox.TryGetToolByName("cursorTool").isMode("interaction") &&
            canv.canvasController.selected.length === 1 &&
            canv.canvasController.selected[0].onlyChild() instanceof mindMapWidget &&
            canv.canvasController.selected[0].onlyChild().interactionType ===
                "select";

        if (
            !canv.toolBox.TryGetToolByName("cursorTool").isMode("interaction") ||
            isOnlyMindMap
        ) {
            menu += this.applyContextMenuItemTemplate(
                "Комментировать",
                "C",
                "comment",
            );
            menu += dividor;
            if (!selectOnlyEmbed) {
                menu += this.applyContextMenuItemTemplate(
                    "Перенести вперед",
                    actionSymbol + " ]",
                    "toFront",
                );
                menu += this.applyContextMenuItemTemplate(
                    "Перенести назад",
                    actionSymbol + " [",
                    "toBack",
                );
            }
            menu += this.applyContextMenuItemTemplateWithSubMenu(
                "Выровнять",
                "&#62",
                "arrange",
                [
                    { text: "Левый край", codeName: "alignLeft", shortcut: "" },
                    {
                        text: "Центры горизонтально",
                        codeName: "alignHCenters",
                        shortcut: "",
                    },
                    { text: "Правый край", codeName: "alignRight", shortcut: "" },
                    { text: "Верхний край", codeName: "alignTop", shortcut: "" },
                    {
                        text: "Центры вертикально",
                        codeName: "alignVCenters",
                        shortcut: "",
                    },
                    { text: "Нижний край", codeName: "alignBottom", shortcut: "" },
                ],
            );
            menu += dividor;
            menu += this.applyContextMenuItemTemplate("Шаг вперед", "", "redo");
            menu += this.applyContextMenuItemTemplate("Шаг назад", "", "undo");
            menu += dividor;
            if (!selectOnlyEmbed) {
                menu += this.applyContextMenuItemTemplate(
                    "Скопировать как PNG",
                    "",
                    "copyAsPng",
                );
                if (!canv.isBoardModeViewWithMini() && !this.isExporting) {
                    menu += this.applyContextMenuItemTemplate(
                        "Экспортировать",
                        "",
                        "export",
                    );
                }
            }
            if (canv.canvasController.selected.length === 1) {
                menu += this.applyContextMenuItemTemplate(
                    "Скопировать ссылку",
                    "",
                    "linkToWidget",
                );
            }
            menu += dividor;
        }

        menu += this.applyContextMenuItemTemplate("Удалить", "Backspace", "delete");

        return menu;
    }

    buildCanvasContextMenuContent() {
        var actionSymbol = canv.actionManager.actionSymbol;

        var menu = ``;
        var dividor = `<div class="contextMenu_dividor"></div>`;

        menu += this.applyContextMenuItemTemplate(
            "Вставить",
            actionSymbol + " V",
            "paste",
        );
        menu += this.applyContextMenuItemTemplate("Комментировать", "C", "comment");
        menu += dividor;
        menu += this.applyContextMenuItemTemplate("Добавить стикер", "N", "sticky");
        menu += this.applyContextMenuItemTemplate("Добавить текст", "T", "text");
        menu += this.applyContextMenuItemTemplate(
            "Добавить фигуру",
            "S",
            "addShape",
        );

        return menu;
    }

    contextMenuItemClickProccessor(e) {
        var item = getTarget(e, "contextMenuItem");
        var codeName = item.getAttribute("codeName");
        this.callProccessorByCodeName(codeName);
        this.tryHide();
    }

    async callProccessorByCodeName(codeName) {
        if (codeName === "cut") {
            const commandMem = canv.keyboard.command;
            canv.keyboard.command = "ctrl+x";
            canv.toolBox.TryGetToolByName("cursorTool").TryAction("keyboardDown");
            canv.keyboard.command = commandMem;
        }
        if (codeName == "copy") {
            const commandMem = canv.keyboard.command;
            canv.keyboard.command = "ctrl+c";
            canv.toolBox.TryGetToolByName("cursorTool").TryAction("keyboardDown");
            canv.keyboard.command = commandMem;
        } else if (codeName == "paste") {
            const commandMem = canv.keyboard.command;
            canv.keyboard.command = "ctrl+v";
            canv.toolBox.TryGetToolByName("cursorTool").TryAction("keyboardDown");
            canv.keyboard.command = commandMem;
        } else if (codeName === "comment") {
            const commentTool = canv.toolBox.TryGetToolByName("commentTool");
            commentTool.createComment();
            canv.redraw();
        } else if (codeName == "duplicate") {
            // todo: duplicate
            // тут надо поддержать проброс при isInteraction, как для copy и paste
            // await canv.canvasController.copyProccessor();
            // await pasteProccessor();
            // canv.redraw();
        } else if (codeName == "toFront") {
            canv.canvasController.toProccessor("front");
            canv.redraw();
        } else if (codeName == "toBack") {
            canv.canvasController.toProccessor("back");
            canv.redraw();
        } else if (codeName == "sticky") {
            var stickerTool = canv.toolBox.TryGetToolByName("stickerTool");
            stickerTool.createSticker();
            canv.redraw();
        } else if (codeName == "text") {
            var textTool = canv.toolBox.TryGetToolByName("textTool");
            textTool.createText();
            canv.redraw();
        } else if (codeName == "delete") {
            const commandMem = canv.keyboard.command;
            canv.keyboard.command = "Backspace";
            canv.toolBox.TryGetToolByName("cursorTool").TryAction("keyboardDown");
            canv.keyboard.command = commandMem;
        } else if (codeName == "addShape") {
            var textTool = canv.toolBox.TryGetToolByName("shapeTool");
            textTool.createShape();
            canv.redraw();
        } else if (codeName == "copyAsPng") {
            this.exportAs("png");
        } else if (codeName == "export") {
            canv.appInterface.exportWindow.open();
        } else if (codeName == "linkToWidget") {
            await this.linkToWidget();
        } else if (codeName == "undo") {
            canv.eventManager.Undo();
        } else if (codeName == "redo") {
            canv.eventManager.Redo();
        } else if (codeName == "alignLeft") {
            canv.canvasController.alignSelected("left");
        } else if (codeName == "alignHCenters") {
            canv.canvasController.alignSelected("hCenters");
        } else if (codeName == "alignRight") {
            canv.canvasController.alignSelected("right");
        } else if (codeName == "alignTop") {
            canv.canvasController.alignSelected("top");
        } else if (codeName == "alignVCenters") {
            canv.canvasController.alignSelected("vCenters");
        } else if (codeName == "alignBottom") {
            canv.canvasController.alignSelected("bottom");
        }
    }

    exportAs(mode = "png") {
        var savedTransformation = {
            0: canv.m[0],
            3: canv.m[3],
            4: canv.m[4],
            5: canv.m[5],
        };
        canv.multiManager.changeVisibilityCursor(false);
        canv.zoomToSelected();

        // готовим props
        var props = canv.canvasController.getSelectedProps();
        var selectedGroups = canv.canvasController.getSelected();
        selectionManager.clearSelected();

        // create canvas
        var newCanvas = document.createElement("canvas");
        newCanvas.classList.add("exportCanvas");
        document.body.prepend(newCanvas);

        // setup canvas
        var visualWidth = (props["width"] / canv.dpr) * canv.m[0];
        var visualHeight = (props["height"] / canv.dpr) * canv.m[0];

        newCanvas.style.width = visualWidth.toString() + "px";
        newCanvas.style.height = visualHeight.toString() + "px";

        var rect = newCanvas.getBoundingClientRect();
        newCanvas.width = rect.width * canv.dpr;
        newCanvas.height = rect.height * canv.dpr;

        var newCtx = newCanvas.getContext("2d");
        var appCtx = canv.ctx;
        canv.ctx = newCtx;

        canv.ctx.setTransform(
            canv.m[0],
            0,
            0,
            canv.m[3],
            -props["startX"] * canv.m[0],
            -props["startY"] * canv.m[0],
        );

        const groupsForExport = [];
        selectedGroups.forEach((group) => {
            groupsForExport.push(group);

            group.children.forEach((child) => {
                // по требованию экспортируем все содержимое frameWidget даже не выделенное
                if (child instanceof frameWidget) {
                    groupsForExport.push(...child.getOverlappedGroups());
                }
            });
        });

        // рисуем на новом canvas
        canv.redraw();
        canv.redraw(true, true, groupsForExport);

        var isChromium = !!window["chrome"];

        if (mode === "png") {
            if (isChromium) {
                this.copyAsPngChomium(newCanvas);
            } else {
                this.copyAsPngW(newCanvas);
            }
        }
        canv.multiManager.changeVisibilityCursor(true);

        // возвращаем все на место
        canv.ctx = appCtx;
        selectionManager.setSelected(selectedGroups);

        canv.m[0] = savedTransformation["0"];
        canv.m[3] = savedTransformation["3"];
        canv.m[4] = savedTransformation["4"];
        canv.m[5] = savedTransformation["5"];
        canv.ctx.setTransform(canv.m[0], 0, 0, canv.m[3], canv.m[4], canv.m[5]);
    }

    copyAsPngW(newCanvas) {
        if (
            typeof ClipboardItem == undefined ||
            navigator.clipboard == undefined ||
            navigator.clipboard.write == undefined
        )
            return;
        const makeImagePromise = async () => {
            if (
                navigator.permissions != undefined &&
                navigator.permissions.query != undefined
            ) {
                try {
                    const permission = await navigator.permissions.query({
                        name: "clipboard-write",
                    });
                } catch (e) {
                    return;
                }
            }

            var snapshot = await new Promise((resolve) =>
                newCanvas.toBlob(resolve, "image/png", 1),
            );
            newCanvas.outerHTML = "";
            return snapshot;
        };

        navigator.clipboard.write([
            new ClipboardItem({
                ["image/png"]: makeImagePromise(),
            }),
        ]);
    }

    async copyAsPngChomium(newCanvas) {
        const blob = await new Promise((resolve) =>
            newCanvas.toBlob(resolve, "image/png", 1),
        );

        newCanvas.outerHTML = "";

        if (
            navigator.permissions != undefined &&
            navigator.permissions.query != undefined
        ) {
            try {
                const permission = await navigator.permissions.query({
                    name: "clipboard-write",
                });
            } catch (e) {
                return;
            }
        }

        navigator.clipboard.write([
            new ClipboardItem({
                ["image/png"]: blob,
            }),
        ]);
    }

    async linkToWidget() {
        const pathToGroup = `${canv.host}/board/${canv.getInitDataProp("boardUID")}?linkToWidget=${canv.canvasController.selected[0].UID}`;
        saveTextToClipboard(pathToGroup);
    }

    isOpened = false;
}
